import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    constructor() { }

    /**
     * Store data in local storage
     * @param key 
     * @param value 
     */
    storeData(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    /**
     * Get data from local storage
     * @param key 
     * @returns 
     */
    getData(key: string): any {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    }

    /**
     * Remove data from local storage
     * @param key 
     */
    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    /**
     * Clear all local storage
     */
    clear(): void {
        localStorage.clear();
    }
}
